import { CreateMycarValetResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { CreateMycarValetModel } from './create-mycar-valet.state';

/** StateDetailsActions */
const ACTION_SET = '[CreateMycarValet] set';
const ACTION_UPDATE = '[CreateMycarValet] update';
const ACTION_RESET = '[CreateMycarValet] reset';
const ACTION_FAIL = '[CreateMycarValet] fail';
const ACTION_CANCEL_REQUEST = '[CreateMycarValet] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[CreateMycarValet] set from api';
const ACTION_UPDATE_FROM_API = '[CreateMycarValet] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setCreateMycarValet = createAction(ACTION_SET, props<WithRequestId<CreateMycarValetModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateCreateMycarValet = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<CreateMycarValetModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetCreateMycarValet = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelCreateMycarValetRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failCreateMycarValet = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setCreateMycarValetFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<CreateMycarValetResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateCreateMycarValetFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<CreateMycarValetResponse>>()
);
